export const getDefaultReceipt = (receiptList = []) =>
  receiptList.find((receipt) => receipt.default === true);

export const getDefaultPrinter = (receiptPrinterIPs = [], defaultReceipt) =>
  receiptPrinterIPs.find((printer) => printer.receiptId === defaultReceipt?._id);

export const hasMultipleActiveReceipts = (receiptList = []) =>
  receiptList.filter((receipt) => receipt.isAvailable === true).length >= 2;

export const getPrintersForReceipts = (
  receiptList = [],
  receiptPrinterIPs = [],
  items = []
) =>
  receiptList
    .filter((receipt) => receipt.isAvailable)
    .map((receipt) => {
      const printer = receiptPrinterIPs.find(
        (item) => item.receiptId === receipt._id
      );

      if (!printer?.ipAddress) return null;

      const hasItemsForReceipt = items.some((item) =>
        receipt.categories?.includes(item.categoryId)
      );

      if (!hasItemsForReceipt) return null;

      return {
        receipt,
        ipAddress: printer.ipAddress,
        port: printer.port || 9100,
      };
    })
    .filter(Boolean);

export const getFailedPrinterNames = (printers = [], failPrinters = []) =>
  printers
    .filter(
      (printer) =>
        failPrinters.includes(printer.ipAddress) &&
        printer.receipt?.isAvailable === true
    )
    .map((printer) => printer.receipt?.name || printer.ipAddress);

export const hasStationDataChanged = (stationCategories = [], updatedCartItems = []) => {
  const updatedStationItems = updatedCartItems.filter((item) =>
    stationCategories.includes(item.categoryId)
  );

  return updatedStationItems.some(
    (item) => item.isPrinted === false || item.isVoidItem === true
  );
};